/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDeveloperAppResponse
 */
export interface CreateDeveloperAppResponse {
    /**
     * The API key (address) for the developer app
     * @type {string}
     * @memberof CreateDeveloperAppResponse
     */
    apiKey?: string;
    /**
     * The private key for the developer app (for signing)
     * @type {string}
     * @memberof CreateDeveloperAppResponse
     */
    apiSecret?: string;
    /**
     * The bearer token for API authentication (use in Authorization header)
     * @type {string}
     * @memberof CreateDeveloperAppResponse
     */
    bearerToken?: string;
    /**
     * Transaction hash of the creation
     * @type {string}
     * @memberof CreateDeveloperAppResponse
     */
    transactionHash?: string;
    /**
     * The blockchain block hash
     * @type {string}
     * @memberof CreateDeveloperAppResponse
     */
    blockHash?: string;
    /**
     * The blockchain block number/height
     * @type {number}
     * @memberof CreateDeveloperAppResponse
     */
    blockNumber?: number;
}

/**
 * Check if a given object implements the CreateDeveloperAppResponse interface.
 */
export function instanceOfCreateDeveloperAppResponse(value: object): value is CreateDeveloperAppResponse {
    let isInstance = true;

    return isInstance;
}

export function CreateDeveloperAppResponseFromJSON(json: any): CreateDeveloperAppResponse {
    return CreateDeveloperAppResponseFromJSONTyped(json, false);
}

export function CreateDeveloperAppResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDeveloperAppResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'apiKey': !exists(json, 'api_key') ? undefined : json['api_key'],
        'apiSecret': !exists(json, 'api_secret') ? undefined : json['api_secret'],
        'bearerToken': !exists(json, 'bearer_token') ? undefined : json['bearer_token'],
        'transactionHash': !exists(json, 'transaction_hash') ? undefined : json['transaction_hash'],
        'blockHash': !exists(json, 'block_hash') ? undefined : json['block_hash'],
        'blockNumber': !exists(json, 'block_number') ? undefined : json['block_number'],
    };
}

export function CreateDeveloperAppResponseToJSON(value?: CreateDeveloperAppResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'api_key': value.apiKey,
        'api_secret': value.apiSecret,
        'bearer_token': value.bearerToken,
        'transaction_hash': value.transactionHash,
        'block_hash': value.blockHash,
        'block_number': value.blockNumber,
    };
}

